window.BAO.DrawerTrigger = class DrawerTrigger extends (
  window.BAO.CustomElement()
) {
  static get requiredElements () {
    return ['image', 'selected']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  updateSelectedDisplay () {
    throw new Error('Needs to be implemented')
  }

  /**
   * @param {HTMLImageElement} image
   * @param {HTMLImageElement} imageToUpdateWith
   */
  updateImage (image, imageToUpdateWith) {
    if (!image) return
    if (!imageToUpdateWith) return

    image.src = imageToUpdateWith.src
    image.srcset = imageToUpdateWith.srcset
  }

  /**
   * @param {number} number
   *
   * @returns {string}
   */
  numberToWord (number) {
    const numbers = new Map([
      [1, 'One'],
      [2, 'Two'],
      [3, 'Three'],
      [4, 'Four'],
      [5, 'Five'],
      [6, 'Six'],
      [7, 'Seven'],
      [8, 'Eight'],
      [9, 'Nine'],
      [10, 'Ten'],
      [11, 'Eleven'],
      [12, 'Twelve'],
      [13, 'Thirteen'],
      [14, 'Fourteen'],
      [15, 'Fifteen'],
      [16, 'Sixteen'],
      [17, 'Seventeen'],
      [18, 'Eighteen'],
      [19, 'Nineteen'],
      [20, 'Twenty'],
    ])

    return numbers.get(number)
  }

  get image () {
    return this.els.image.element.querySelector('img')
  }
}

if (!customElements.get('drawer-trigger')) {
  customElements.define('drawer-trigger', window.BAO.DrawerTrigger)
}
